<script>
import api from '@/utils/api'
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'
import { ORGANIZATION_VIEW_ROUTE_NAME } from '@/router/client'
import BankMixin from '@/mixins/bankMixin'
import AppLogger from '@/utils/appLogger'

export default {
  name: 'OrganizationMixin',
  mixins: [ApiErrorMixin, BankMixin],
  methods: {
    async createOrganization (modelData, edit) {
      const model = { ...modelData }
      if (model.fileList && model.fileList.length) {
        model.file = { id: model.fileList[0].id }
      }
      if (model.bank && !model.bank.id) {
        model.bank = null
      }
      delete model.fileList

      this.showPageLoader()
      const params = { path: 'ORGANIZATION_PATH', model }
      let requestResponse

      if (!model.file.id) {
        delete model.file
      }

      if (edit) {
        requestResponse = await api.patch(params)
      } else {
        requestResponse = await api.post(params)
      }
      const response = this.checkApiResponse(requestResponse)
      if (response && response.id) {
        if (edit) {
          window.location.reload()
        } else {
          this.$router.push({ name: ORGANIZATION_VIEW_ROUTE_NAME, params: { id: response.id } })
        }
      } else {
        this.hidePageLoader()
      }
    },
    async inviteAdmin (model) {
      this.showPageLoader()
      const params = { path: 'INVITE_USER_PATH', model }
      const requestResponse = await api.post(params)
      const response = this.checkApiResponse(requestResponse)

      if (response && response.id) {
        this.$router.push({ name: ORGANIZATION_VIEW_ROUTE_NAME, params: { id: model.organization.id } }, () => {
          window.location.reload()
        })
      }
      this.hidePageLoader()
    },
    async activeOffice (model) {
      const checkActivation = this.checkActivation()
      if (!checkActivation) {
        return
      }

      AppLogger.info(model.location, 'model.location')
      this.showPageLoader()
      const params = {
        path: 'OFFICE_PATH',
        model: {
          ...model,
          location: {
            ...model.location,
            timeZone: model.location.timeZone.id
          }
        },
        suffixId: true,
        addPath: '/active'
      }
      const requestResponse = await api.patch(params)
      const response = this.checkApiResponse(requestResponse)

      if (response && response.id) {
        window.location.reload()
      } else {
        this.hidePageLoader()
      }
    },
    async createMeetPoint (meetingPoint) {
      const model = {
        ...meetingPoint,
        metroStationList: meetingPoint.metroStationList.filter((item) => !!item.id).map((item) => ({ id: item.id }))
      }
      if (meetingPoint.coordinate.latitude === null || meetingPoint.coordinate.longitude === null) {
        model.coordinate = null
      }
      this.showPageLoader()
      const params = { path: 'MEET_POINT_PATH', model }
      const requestResponse = await api.post(params)
      const response = this.checkApiResponse(requestResponse)

      if (response && response.id) {
        // this.$router.push({ name: OFFICE_VIEW_ROUTE_NAME, params: { id: model.office.id } }, () => {
        window.location.reload()
        // })
      } else {
        this.hidePageLoader()
      }
    },
    async createTransportation (transportation) {
      const model = {
        ...transportation,
      }

      this.showPageLoader()
      const params = { path: 'MEET_POINT_PATH', model }
      const requestResponse = await api.post(params)
      const response = this.checkApiResponse(requestResponse)

      if (response && response.id) {
        // this.$router.push({ name: OFFICE_VIEW_ROUTE_NAME, params: { id: model.office.id } }, () => {
        window.location.reload()
        // })
      } else {
        this.hidePageLoader()
      }
    },
    async loadFile (file, model, key, prop = 'fileList', externalOrganizationId = null, callback = null, checkMissing) {
      if (file && file.type && file.constructor.name === 'File' && !this.$store.state.common.FILE_LOADING) {
        const formData = new FormData()
        formData.append(key, file)
        if (externalOrganizationId) {
          formData.append('externalClient', externalOrganizationId)
        }
        if (checkMissing) {
          formData.append('checkMissing', '1')
        }
        // formData.append('name', this.model.name)

        try {
          this.showPageLoader()
          this.$store.commit(`${storeUtils.setterName(storeLabel.FILE_LOADING, storeLabel.COMMON_MODULE)}`, true)
          const requestResponse = await api.loadFile(`${this.appConfig.getEnvParameter('MEDIA_PATH')}`, formData)
          const response = this.checkApiResponse(requestResponse)
          if (response.id) {
            const loadedFile = { name: file.name, type: file.type, ...response }
            if (!checkMissing) {
              model[prop].push(loadedFile)
            }
            if (callback && typeof callback === 'function') {
              callback(response)
            }
            // '68375240', '68375241', '68375242', '68375245'
            this.hidePageLoader()
            this.$store.commit(`${storeUtils.setterName(storeLabel.FILE_LOADING, storeLabel.COMMON_MODULE)}`, false)
            return response
          } else {
            /**
                   * @todo no file
                   */
          }
          this.hidePageLoader()
          this.$store.commit(`${storeUtils.setterName(storeLabel.FILE_LOADING, storeLabel.COMMON_MODULE)}`, false)
        } catch (e) {
          this.hidePageLoader()
          this.$store.commit(`${storeUtils.setterName(storeLabel.FILE_LOADING, storeLabel.COMMON_MODULE)}`, false)
          console.log(e)
          return null
        }

        return null
      }
    },
  }
}
</script>
